// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_t3F","right":"styles_right__A_evH"};